import { CompareHealthQuoteParams } from '@apis/HealthQuoteApi';
import { getRoute } from '@utils/route';

export type HealthQuoteComparePageParams = CompareHealthQuoteParams

export const HEALTH_QUOTE_COMPARE_PAGE_URL = '/health-insurance-quote-compare';

export const routeHealthQuoteComparePage = (searchParams: HealthQuoteComparePageParams) => getRoute(HEALTH_QUOTE_COMPARE_PAGE_URL, { searchParams });
